import { FC } from "react";

type Props = {
  answers: Array<string>;
};

const Answers: FC<Props> = ({ answers }) => (
  <div className="flex flex-column">
    {answers.map((answer, index) => (
      <span key={`${answer}_${index}`}>{answer}</span>
    ))}
  </div>
);

export default Answers;
